module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"trucks":"{n} Truck | {n} Trucks"},"de":{"trucks":"{n} Fahrzeug | {n} Fahrzeuge"},"fr":{"trucks":"{n} Camion | {n} Camions"},"it":{"trucks":"{n} Camion | {n} Camion"}}')
  delete Component.options._Ctor
}
